import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonService } from '@services/common.service';

@Component({
  selector: 'market-dialog-bottom-up',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dialog-bottom-up.component.html',
  styleUrl: './dialog-bottom-up.component.scss',
})
export class DialogBottomUpComponent {
  @Output() dialogClose = new EventEmitter();
  @ViewChild('dialog') dialog!: ElementRef<HTMLDialogElement>;
  loading = inject(CommonService).loading;
  dialogCloseHandler() {
    this.dialogClose.emit();
  }
  public showModal() {
    this.dialog.nativeElement.showModal();
  }
  public hideModal() {
    this.dialog.nativeElement.close();
  }
}
